export const SET_AMBASSADOR_LIST = "SET_AMBASSADOR_LIST";



